import React from 'react';


const SeasonTimeline = ({ season, loading }) => {
  if (loading) {
    return (
      <div className="card p-6 animate-pulse">
        <div className="h-4 bg-surface-700 rounded w-1/3 mb-4" />
        <div className="h-3 bg-surface-700 rounded w-full mb-2" />
        <div className="h-3 bg-surface-700 rounded w-2/3" />
      </div>
    );
  }

  const now = new Date();
  const start = season ? new Date(season.start_date) : now;
  const end = season ? new Date(season.end_date) : new Date(now.getTime() + 28 * 24 * 60 * 60 * 1000);
  const totalDuration = end - start;
  const elapsed = Math.max(0, now - start);
  const progressPct = Math.min(100, (elapsed / totalDuration) * 100);
  const daysRemaining = Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
  const weekNumber = Math.min(4, Math.ceil(elapsed / (7 * 24 * 60 * 60 * 1000)) || 1);

  const weeks = [1, 2, 3, 4];

  const modifiers = season?.active_modifiers || {};

  return (
    <div className="card p-6">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-lg font-bold text-foreground">
            {season?.season_name || 'Season 1: Rise of Empires'}
          </h2>
          <p className="text-sm text-muted mt-0.5">
            Theme: <span className="text-accent">{season?.season_theme || 'Industrial Revolution'}</span>
          </p>
        </div>
        <div className="text-right">
          <div className="text-2xl font-bold text-primary">{daysRemaining}d</div>
          <div className="text-xs text-muted">remaining</div>
        </div>
      </div>
      {/* Progress Bar */}
      <div className="mb-4">
        <div className="flex justify-between text-xs text-muted mb-1">
          <span>Week 1</span>
          <span>Week 2</span>
          <span>Week 3</span>
          <span>Week 4</span>
        </div>
        <div className="relative h-3 bg-surface-700 rounded-full overflow-hidden">
          <div
            className="absolute left-0 top-0 h-full bg-gradient-to-r from-primary to-accent rounded-full transition-all duration-500"
            style={{ width: `${progressPct}%` }}
          />
          {weeks?.map((w) => (
            <div
              key={w}
              className="absolute top-0 h-full w-px bg-surface-600"
              style={{ left: `${(w - 1) * 25}%` }}
            />
          ))}
        </div>
        <div className="flex justify-between text-xs text-muted mt-1">
          <span>{start?.toLocaleDateString()}</span>
          <span className="text-primary font-medium">Week {weekNumber} of 4</span>
          <span>{end?.toLocaleDateString()}</span>
        </div>
      </div>
      {/* Active Modifiers */}
      {Object.keys(modifiers)?.length > 0 && (
        <div className="mt-4">
          <p className="text-xs text-muted uppercase tracking-wider mb-2">Active Season Modifiers</p>
          <div className="flex flex-wrap gap-2">
            {Object.entries(modifiers)?.map(([key, val]) => (
              <span
                key={key}
                className="px-2 py-1 rounded text-xs font-medium bg-primary/10 text-primary border border-primary/20"
              >
                {key?.replace(/_/g, ' ')?.replace(/\b\w/g, c => c?.toUpperCase())}: {val > 1 ? `+${Math.round((val - 1) * 100)}%` : `${Math.round(val * 100)}%`}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SeasonTimeline;
